export default "__VITE_ASSET__DnzyqeOy__"